/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ActualizarContactoME { 
    contactoId?: number;
    tipoIdentificacionId?: number;
    contactoComplementoId?: number;
    usuarioId?: string;
    contactoNombre?: string;
    identificacion?: string;
    numeroCuenta?: string;
    correoElectronico?: string;
    telefono?: string;
    tipoIdentificacionDescripcion?: string;
    tipoCuentaLlave?: string;
    tipoCuentaValor?: string;
    tipoInstitucionCodigo?: string;
    tipoInstitucionNombre?: string;
    institucionNombre?: string;
    esInterno?: boolean;
    estaActivo?: boolean;
    institucionSecuencial?: number;
}